import React, { useState } from "react";
import {
  Box,
  List,
  ListItemText,
  Chip,
  CircularProgress,
  Grid,
  useTheme,
  useMediaQuery,
  Paper,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  Typography,
  Tabs,
  Tab,
  Menu,
  MenuItem,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LinkIcon from "@mui/icons-material/Link";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { useQuery } from "@apollo/client";
import jwtDecode from "jwt-decode";
import StaffProfile from "./staffProfile";
import BookingTypeStaffForm from "./bookingTypeStaffForm";
import { useLocation, useSearchParams } from "react-router-dom";
import { GET_TOKEN } from "../../../../../platform/graphql/queries";
import WorkingHourView from "../../../../../platform/components/business/workingHourView";
import { EntityType } from "../../../../../platform/redux/actions/businessActions";
import CalendarIntegration from "../../../../../platform/components/business/integeration/calendarIntegration";
import ImageEntryForm from "../../../../../platform/components/business/image/imageEntryForm";
import StaffDocumentsTab from "./staffDocumentsTab";
import StaffAttendanceTab from "./staffAttendanceTab";
import { useSelectedBusiness } from "../../../../../platform/redux/store";



const StaffDetailHorizontalTab = (props) => {
  const selectedBusiness = useSelectedBusiness();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");



  const tabIndex = parseInt(tab || "0", 10);
  const [selectedIndex, setSelectedIndex] = useState(tabIndex ?? 0);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const closeMoreMenu = () => setMoreAnchorEl(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleMenuItemClick = (index) => {
    setSelectedIndex(index);
  };

  const staffData = props.businessStaff;
  const businessId = props?.businessId ?? selectedBusiness?.businessBasic?.id;








  const {
    loading: tokenLoading,
    error: tokenError,
    data: tokenData,
    refetch: tokenRefetch,
  } = useQuery(GET_TOKEN, {
    variables: {
      userId: null,
      staffId: Number(staffData?.id),
      subscriptionId: null,
      businessId: null,
    },
  });

  const decodedToken =
    tokenData && tokenData !== "undefined"
      ? jwtDecode(tokenData.getToken.token)
      : null;

  if (tokenLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress disableShrink size={100} />
      </Box>
    );
  }

  const menuItems = [
    { label: "Profile", mobileLabel: "Profile", index: 0, icon: <PersonIcon fontSize="small" /> },
    { label: "Working Hour", mobileLabel: "Hours", index: 1, icon: <AccessTimeIcon fontSize="small" /> },
    { label: "Assignments", mobileLabel: "Assign", index: 2, icon: <AssignmentIcon fontSize="small" /> },
    { label: "Integration", mobileLabel: "Integrate", index: 3, icon: <LinkIcon fontSize="small" /> },
    { label: "Document", mobileLabel: "Docs", index: 4, icon: <DescriptionIcon fontSize="small" /> },
    { label: "Image", mobileLabel: "Image", index: 5, icon: <ImageIcon fontSize="small" /> },
    { label: "Attendance", mobileLabel: "Attend", index: 6, icon: <FactCheckIcon fontSize="small" /> },
  ];
  const MOBILE_VISIBLE_TAB_COUNT = 4;
  const mobileVisibleItems = menuItems.slice(0, MOBILE_VISIBLE_TAB_COUNT);
  const mobileOverflowItems = menuItems.slice(MOBILE_VISIBLE_TAB_COUNT);
  const isOverflowSelected = mobileOverflowItems.some((item) => item.index === selectedIndex);
  const mobileTabValue = isOverflowSelected ? false : selectedIndex;
  const overflowActiveItem = mobileOverflowItems.find((item) => item.index === selectedIndex) || null;

  return staffData ? (
    <Grid container spacing={2}>
      {/* Left column for menu */}
      <Grid item xs={12} md={3} sx={{ height: "auto" }}>
        {isMobile ? (
          <Box
            sx={{
              mb: 1.5,
              position: "sticky",
              top: "calc(var(--business-header-height, 0px) + 4px)",
              zIndex: (t) => t.zIndex.appBar - 1,
              bgcolor: "background.paper",
              border: (t) => `1px solid ${t.palette.divider}`,
              borderRadius: 2,
              boxShadow: "0 6px 14px rgba(15,23,42,0.08)",
            }}
          >
            <Tabs
              value={mobileTabValue}
              onChange={(e, next) => {
                if (next === "more") {
                  setMoreAnchorEl(e.currentTarget);
                  return;
                }
                handleMenuItemClick(next);
                closeMoreMenu();
              }}
              variant="fullWidth"
              aria-label="Staff detail tabs"
              sx={{
                minHeight: 46,
                "& .MuiTab-root": {
                  minHeight: 46,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: 11.5,
                  px: 0.5,
                  minWidth: 0,
                },
              }}
            >
              {mobileVisibleItems.map((item) => (
                <Tab
                  key={item.index}
                  value={item.index}
                  icon={item.icon}
                  iconPosition="start"
                  label={item.mobileLabel || item.label}
                />
              ))}
              {mobileOverflowItems.length > 0 && (
                <Tab value="more" label="More" />
              )}
            </Tabs>
            <Menu
              anchorEl={moreAnchorEl}
              open={Boolean(moreAnchorEl)}
              onClose={closeMoreMenu}
              keepMounted
              disableScrollLock
            >
              {mobileOverflowItems.map((item) => (
                <MenuItem
                  key={item.index}
                  selected={selectedIndex === item.index}
                  onClick={() => {
                    handleMenuItemClick(item.index);
                    closeMoreMenu();
                  }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
            {isOverflowSelected && overflowActiveItem && (
              <Box sx={{ px: 1, pb: 0.75 }}>
                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
                  Selected: {overflowActiveItem.mobileLabel || overflowActiveItem.label}
                </Typography>
              </Box>
            )}
          </Box>
        ) : (
          // Desktop: Left rail menu
          <Paper
            elevation={0}
            sx={{
              position: "sticky",
              top: 16,
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              borderRight: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
            }}
          >
            <List
              dense
              subheader={
                <ListSubheader component="div" sx={{ fontWeight: 700, bgcolor: "transparent" }}>
                  Staff Menu
                </ListSubheader>
              }
              sx={{
                py: 1,
                "& .MuiListItemButton-root": {
                  borderRadius: 1.5,
                  mx: 1,
                  my: 0.5,
                },
                "& .Mui-selected": {
                  bgcolor: (t) => t.palette.action.selected,
                  "&:hover": { bgcolor: (t) => t.palette.action.selected },
                },
              }}
            >
              {menuItems.map((item) => {
                const selected = selectedIndex === item.index;
                return (
                  <ListItemButton
                    key={item.index}
                    selected={selected}
                    onClick={() => handleMenuItemClick(item.index)}
                    sx={{
                      position: "relative",
                      "&.Mui-selected::before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 6,
                        bottom: 6,
                        width: 3,
                        borderRadius: 2,
                        bgcolor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontWeight: selected ? 700 : 500,
                        fontSize: 14,
                      }}
                    />
                  </ListItemButton>
                );
              })}
            </List>
          </Paper>
        )}
      </Grid>

      {/* Right column for content */}
      <Grid item xs={12} md={9} sx={{ padding: 2 }}>
        {selectedIndex === 0 && <StaffProfile staff={staffData} />}
        {selectedIndex === 1 && (
          <WorkingHourView
            key={Math.floor(Math.random() * 1000)}
            providerUser={decodedToken}
            workingHourDatas={[]}
            isDisabled={props.isCalenderDisabled}
            entityType={EntityType.STAFF}
            isCustom={false}
            defaultWH={true}
            staffData={staffData}
          />
        )}
        {selectedIndex === 2 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
              <Box
                sx={{
                  mb: 1,
                  p: 1,
                  borderRadius: 1.5,
                  bgcolor: "background.paper",
                  border: "1px solid rgba(15,23,42,0.06)",
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 0.25 }}>
                  Booking Assignments
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Booking services currently linked to this staff profile.
                </Typography>
              </Box>
              <Box
                sx={{
                  maxHeight: { xs: 320, sm: 380, md: 420 },
                  overflowY: "auto",
                  pr: 0.25,
                }}
              >
                <BookingTypeStaffForm
                  staff={staffData}
                  isDisabled={props.isBookingTypeDisabled}
                />
              </Box>
            </Paper>


          </Box>
        )}
        {selectedIndex === 3 && (
          <CalendarIntegration
            isDisabled={props.isStaffCanEditItsEmailIntegeration}
          />
        )}
        {selectedIndex === 4 && (
          <StaffDocumentsTab
            staffId={staffData?.id}
            isDisabled={props.isStaffCanEditItsEmailIntegeration}
          />
        )}
        {selectedIndex === 5 && (
          <ImageEntryForm
            singleImageMode={true}
            avatar={true}
            staffId={staffData?.id}
            isDisabled={props.isStaffCanEditItsImage === false}
          />
        )}
        {selectedIndex === 6 && (
          <StaffAttendanceTab
            staff={staffData}
            isDisabled={props.isCalenderDisabled}
          />
        )}
      </Grid>
    </Grid>
  ) : null;
};

export default StaffDetailHorizontalTab;
